import { ReplicaEntry } from './types';

export const MAX_LOG_CHARS = 1_000_000;

export type ReplicaLogAction = 'wait' | 'stream' | 'ended';

export type ReplicaLogPhase = 'waiting' | 'streaming' | 'ended';

const FINISHED_REPLICA_STATUSES = new Set(['terminated', 'aborted', 'failed', 'done']);

export function isFinishedReplicaStatus(status: string): boolean {
    return FINISHED_REPLICA_STATUSES.has(status);
}

export function replicaLogAction(replica: Pick<ReplicaEntry, 'container_id' | 'status' | 'logs_url'>): ReplicaLogAction {
    if (replica.container_id) {
        return replica.logs_url ? 'stream' : 'ended';
    }
    return isFinishedReplicaStatus(replica.status) ? 'ended' : 'wait';
}

export function initialReplicaLogPhase(replica: Pick<ReplicaEntry, 'container_id' | 'status' | 'logs_url'>): ReplicaLogPhase {
    const action = replicaLogAction(replica);
    if (action === 'stream') return 'streaming';
    if (action === 'ended') return 'ended';
    return 'waiting';
}

export function appendCappedLog(current: string, chunk: string, limit = MAX_LOG_CHARS): string {
    const combined = current + chunk;
    if (combined.length <= limit) return combined;
    let start = combined.length - limit;
    // Keep the retained suffix on a code-point boundary.
    const first = combined.charCodeAt(start);
    if (first >= 0xdc00 && first <= 0xdfff) start += 1;
    return combined.slice(start);
}

export function followLogsUrl(url: string): string {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}follow=true`;
}
